(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-instagram"] && !Shopify.designMode) return;
  try {
    
class SeaShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.slider = null
    this.activeModal = null
    this.lastQuickViewTrigger = null
    this.escapeHandler = this.handleEscape.bind(this)

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    /*
     * Reliable first-load Swiper initialization.
     *
     * Previously this checked for window.Swiper only once after 500ms.
     * On a cold/first browser load the CDN script can take longer than that,
     * so the check returned early and the slider stayed at opacity: 0 until
     * the next page refresh (when the Swiper file was already cached).
     *
     * Keep all existing slider behaviour exactly the same; only wait until
     * Swiper is actually available before creating the instance.
     */
    const initSwiper = () => {
      if (this.slider) return true

      const swiperElement = this.querySelector('.swiper')
      if (!swiperElement || !window.Swiper) return false

      this.slider = new window.Swiper(
        swiperElement,
        this.splideOptions()
      )

      this.slider.on('slideChange', () => {
        this.querySelector('.swiper')?.classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper')?.classList.remove('swiper-is-changing')
      })

      return true
    }

    if (!initSwiper()) {
      const swiperScript = document.querySelector('#swiper-script')

      /*
       * The load event handles normal cold loads.
       * The short retry also covers the tiny race where the script finishes
       * between our initial check and attaching the load listener.
       */
      swiperScript?.addEventListener('load', initSwiper, { once: true })

      let swiperInitAttempts = 0
      const waitForSwiper = window.setInterval(() => {
        swiperInitAttempts += 1

        if (initSwiper() || swiperInitAttempts >= 150) {
          window.clearInterval(waitForSwiper)
        }
      }, 100)
    }

    /* Play button keeps the original play / pause + sound behaviour. */
    this.querySelectorAll('.sea-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        const wrapper = btn.closest('.sea-shoppable-videos-video-wrapper')
        const video = wrapper?.querySelector('video')

        if (video) this.onVideoPlay(video)
      })
    })

    /* Product strip opens the quick product popup instead of leaving the page. */
    this.querySelectorAll('[data-sea-open-quickview]').forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        this.openQuickView(trigger.dataset.seaOpenQuickview, trigger)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.muted = true
      video.defaultMuted = true

      /*
       * Clicking the actual shoppable video opens its product quick view.
       * The centre play button above is kept as the dedicated playback control.
       */
      video.addEventListener('click', (event) => {
        const card = video.closest('.sea-shoppable-videos-card')
        const templateId = card?.dataset.quickViewTemplate

        if (templateId) {
          event.preventDefault()
          event.stopPropagation()

          if (this.slider && this.slider.allowClick === false) return

          this.openQuickView(templateId, video)
          return
        }

        this.onVideoPlay(video)
      })

      video.addEventListener('pause', () => {
        video.muted = true

        const card = video.closest('.sea-shoppable-videos-card')
        if (card) card.setAttribute('data-is-playing', 'false')
      })

      video.addEventListener('ended', () => {
        video.muted = true
      })
    })

    this.videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const video = entry.target
          const card = video.closest('.sea-shoppable-videos-card')

          if (entry.isIntersecting) {
            video.muted = true
            if (card) card.setAttribute('data-is-playing', 'false')

            const playPromise = video.play()
            if (playPromise !== undefined) playPromise.catch(() => {})
          } else {
            video.muted = true
            if (card) card.setAttribute('data-is-playing', 'false')
          }
        })
      },
      {
        rootMargin: '0px 0px 300px 0px',
        threshold: 0.01
      }
    )

    this.querySelectorAll('video[data-autoplay="true"]').forEach(video => {
      this.videoObserver.observe(video)
    })

    this.visibilityHandler = () => {
      if (!document.hidden) return

      this.querySelectorAll('video').forEach(video => {
        video.muted = true
      })

      this.querySelectorAll('.sea-shoppable-videos-card').forEach(card => {
        card.setAttribute('data-is-playing', 'false')
      })

      if (this.activeModal) {
        const popupVideo = this.activeModal.querySelector('.sea-qv-video video')
        if (popupVideo) popupVideo.muted = true
      }
    }

    document.addEventListener('visibilitychange', this.visibilityHandler)
  }

  disconnectedCallback () {
    if (this.videoObserver) this.videoObserver.disconnect()

    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler)
    }

    document.removeEventListener('keydown', this.escapeHandler)
    this.closeQuickView(false)
  }

  splideOptions () {
    const partialSlidesMobile =
      this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    const mobileTwoSlides = this.dataset.mobileTwoSlides === 'true'

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: {
          slidesPerView: mobileTwoSlides
            ? 2
            : Number(this.dataset.breakpointXs) * partialSlidesMobile,
          slidesPerGroup: mobileTwoSlides ? 2 : 1
        },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay:
        this.dataset.sliderAutoplay !== '0'
          ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
          : undefined,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }

  onSlideChange () {
    this.querySelectorAll('.sea-shoppable-videos-card').forEach(card => {
      card.setAttribute('data-is-playing', 'false')

      const video = card.querySelector('video')
      if (video) {
        video.pause()
        video.muted = true
      }
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.sea-shoppable-videos-card')
    if (!card) return

    this.querySelectorAll('.sea-shoppable-videos-card').forEach(otherCard => {
      if (otherCard.dataset.index === card.dataset.index) return

      otherCard.setAttribute('data-is-playing', 'false')
      const otherVideo = otherCard.querySelector('video')

      if (otherVideo) {
        otherVideo.muted = true
        otherVideo.pause()
      }
    })

    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
      video.muted = true
      return
    }

    card.setAttribute('data-is-playing', 'true')
    video.muted = false

    const playPromise = video.play()
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        video.muted = true
        card.setAttribute('data-is-playing', 'false')
      })
    }
  }

  openQuickView (templateId, trigger) {
    const template = document.getElementById(templateId)
    if (!template || !template.content) return

    const sourceCard = trigger?.closest?.('.sea-shoppable-videos-card') ||
      this.querySelector(`.sea-shoppable-videos-card[data-quick-view-template="${templateId}"]`)
    const sourceVideo = sourceCard?.querySelector('video')
    const sourceTime = Number.isFinite(sourceVideo?.currentTime) ? sourceVideo.currentTime : 0

    this.closeQuickView(false)
    this.lastQuickViewTrigger = trigger || sourceCard || null

    /* Stop / mute every card video before opening the product popup. */
    this.querySelectorAll('.sea-shoppable-videos-card video').forEach(video => {
      video.pause()
      video.muted = true
      video.closest('.sea-shoppable-videos-card')?.setAttribute('data-is-playing', 'false')
    })

    const fragment = template.content.cloneNode(true)
    const modal = fragment.querySelector('[data-sea-qv-modal]')
    if (!modal) return

    document.body.appendChild(fragment)
    this.activeModal = document.querySelector(
      `[data-sea-qv-modal][data-owner="${this.id}"]`
    )

    if (!this.activeModal) return

    document.body.classList.add('sea-shoppable-quickview-open')
    document.addEventListener('keydown', this.escapeHandler)

    this.bindQuickView(this.activeModal, sourceTime)

    requestAnimationFrame(() => {
      this.activeModal?.querySelector('.sea-qv-close')?.focus({ preventScroll: true })
    })
  }

  bindQuickView (modal, sourceTime = 0) {
    const closeBtn = modal.querySelector('[data-sea-qv-close]')
    closeBtn?.addEventListener('click', () => this.closeQuickView())

    modal.addEventListener('click', (event) => {
      if (event.target === modal) this.closeQuickView()
    })

    const nextVideoBtn = modal.querySelector('[data-sea-qv-next-video]')
    const quickViewCards = this.querySelectorAll('.sea-shoppable-videos-card[data-quick-view-template]')

    if (nextVideoBtn) {
      if (quickViewCards.length <= 1) {
        nextVideoBtn.hidden = true
      } else {
        nextVideoBtn.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          this.openNextQuickView(modal)
        })
      }
    }

    const popupVideo = modal.querySelector('.sea-qv-video video')
    if (popupVideo) {
      /*
       * The popup is opened by a real click/tap, so request audible playback
       * immediately while that user activation is still active.
       */
      popupVideo.removeAttribute('muted')
      popupVideo.defaultMuted = false
      popupVideo.muted = false
      popupVideo.volume = 1

      if (sourceTime > 0) {
        const syncTime = () => {
          try { popupVideo.currentTime = sourceTime } catch (error) {}
        }

        if (popupVideo.readyState >= 1) syncTime()
        else popupVideo.addEventListener('loadedmetadata', syncTime, { once: true })
      }

      const promise = popupVideo.play()
      if (promise !== undefined) {
        promise.catch(() => {
          /* Keep the popup ready for a normal user play if a browser blocks audio. */
          popupVideo.muted = false
        })
      }
    }

    this.initQuickViewGallery(modal)
    this.initQuickViewVariants(modal)
  }

  openNextQuickView (modal) {
    const cards = Array.from(
      this.querySelectorAll('.sea-shoppable-videos-card[data-quick-view-template]')
    )

    if (cards.length <= 1) return

    const currentTemplateId = modal.dataset.templateId
    let currentIndex = cards.findIndex(card => card.dataset.quickViewTemplate === currentTemplateId)
    if (currentIndex < 0) currentIndex = 0

    const nextCard = cards[(currentIndex + 1) % cards.length]
    const nextTemplateId = nextCard?.dataset.quickViewTemplate
    if (!nextTemplateId) return

    /* A deliberate next action should begin the next popup video from the start. */
    const nextSourceVideo = nextCard.querySelector('video')
    if (nextSourceVideo) {
      try { nextSourceVideo.currentTime = 0 } catch (error) {}
    }

    if (this.slider) {
      const slideIndex = Number(nextCard.dataset.index || 0)
      if (Number.isFinite(slideIndex)) this.slider.slideTo(slideIndex)
    }

    const nextTrigger =
      nextCard.querySelector('[data-sea-open-quickview]') ||
      nextCard.querySelector('video') ||
      nextCard

    this.openQuickView(nextTemplateId, nextTrigger)
  }

  initQuickViewGallery (modal) {
    const images = Array.from(modal.querySelectorAll('[data-sea-qv-image]'))
    const dots = Array.from(modal.querySelectorAll('[data-sea-qv-dot]'))
    const prev = modal.querySelector('[data-sea-qv-prev]')
    const next = modal.querySelector('[data-sea-qv-next]')

    if (!images.length) return

    let current = Math.max(
      0,
      images.findIndex(image => image.classList.contains('is-active'))
    )

    const show = (index) => {
      current = (index + images.length) % images.length

      images.forEach((image, i) => image.classList.toggle('is-active', i === current))
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current)
        dot.setAttribute('aria-current', i === current ? 'true' : 'false')
      })
    }

    modal._seaShowGalleryImage = show

    prev?.addEventListener('click', () => show(current - 1))
    next?.addEventListener('click', () => show(current + 1))

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => show(index))
    })

    if (images.length <= 1) {
      if (prev) prev.hidden = true
      if (next) next.hidden = true
      const dotsWrap = modal.querySelector('.sea-qv-dots')
      if (dotsWrap) dotsWrap.hidden = true
    }

    show(current)
  }

  initQuickViewVariants (modal) {
    const variantsScript = modal.querySelector('[data-sea-qv-variants]')
    if (!variantsScript) return

    let variants = []

    try {
      variants = JSON.parse(variantsScript.textContent || '[]')
    } catch (error) {
      variants = []
    }

    modal._seaVariants = variants

    const selectedId = Number(modal.dataset.selectedVariant || 0)
    const selectedVariant = variants.find(variant => Number(variant.id) === selectedId) || variants[0]

    if (selectedVariant?.options) {
      selectedVariant.options.forEach((value, optionIndex) => {
        const group = modal.querySelector(`[data-option-index="${optionIndex}"]`)
        if (!group) return

        group.querySelectorAll('[data-option-value]').forEach(button => {
          button.classList.toggle('is-selected', button.dataset.optionValue === value)
        })
      })
    }

    modal.querySelectorAll('[data-option-value]').forEach(button => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-option-index]')
        if (!group) return

        group.querySelectorAll('[data-option-value]').forEach(item => {
          item.classList.remove('is-selected')
        })
        button.classList.add('is-selected')

        this.resolveQuickViewVariant(modal)
      })
    })

    this.updateQuickViewVariant(modal, selectedVariant)
  }

  resolveQuickViewVariant (modal) {
    const variants = modal._seaVariants || []
    const selectedOptions = Array.from(modal.querySelectorAll('[data-option-index]')).map(group => {
      return group.querySelector('[data-option-value].is-selected')?.dataset.optionValue || ''
    })

    const variant = variants.find(item => {
      if (!Array.isArray(item.options)) return false
      return selectedOptions.every((value, index) => item.options[index] === value)
    })

    this.updateQuickViewVariant(modal, variant)
  }

  updateQuickViewVariant (modal, variant) {
    const price = modal.querySelector('[data-sea-qv-price]')
    const compare = modal.querySelector('[data-sea-qv-compare]')
    const discount = modal.querySelector('[data-sea-qv-discount]')
    const stock = modal.querySelector('[data-sea-qv-stock]')
    const viewDetails = modal.querySelector('[data-sea-qv-view-details]')

    if (!variant) {
      modal.dataset.selectedVariant = ''
      if (viewDetails && modal.dataset.productUrl) {
        viewDetails.href = modal.dataset.productUrl
      }
      return
    }

    modal.dataset.selectedVariant = variant.id

    const variantPrice = Number(variant.price || 0)
    const comparePrice = Number(variant.compare_at_price || 0)

    if (price) price.textContent = this.formatMoney(variantPrice)

    if (compare) {
      if (comparePrice > variantPrice) {
        compare.hidden = false
        compare.textContent = this.formatMoney(comparePrice)
      } else {
        compare.hidden = true
        compare.textContent = ''
      }
    }

    if (discount) {
      if (comparePrice > variantPrice && comparePrice > 0) {
        const percent = Math.round(((comparePrice - variantPrice) / comparePrice) * 100)
        discount.hidden = false
        discount.textContent = `${percent}% OFF`
      } else {
        discount.hidden = true
        discount.textContent = ''
      }
    }

    if (stock) {
      stock.classList.toggle('is-sold-out', !variant.available)
      stock.textContent = variant.available ? '✓ In Stock' : 'Sold out'
    }

    if (viewDetails && modal.dataset.productUrl) {
      const separator = modal.dataset.productUrl.includes('?') ? '&' : '?'
      viewDetails.href = `${modal.dataset.productUrl}${separator}variant=${variant.id}`
    }

    const featuredImage = variant.featured_image
    if (featuredImage && featuredImage.position && modal._seaShowGalleryImage) {
      const targetIndex = Number(featuredImage.position) - 1
      const totalImages = modal.querySelectorAll('[data-sea-qv-image]').length
      if (targetIndex >= 0 && targetIndex < totalImages) {
        modal._seaShowGalleryImage(targetIndex)
      }
    }
  }

  closeQuickView (restoreFocus = true) {
    if (!this.activeModal) return

    const popupVideo = this.activeModal.querySelector('.sea-qv-video video')
    if (popupVideo) {
      popupVideo.pause()
      popupVideo.muted = true
    }

    this.activeModal.remove()
    this.activeModal = null
    document.body.classList.remove('sea-shoppable-quickview-open')
    document.removeEventListener('keydown', this.escapeHandler)

    if (restoreFocus && this.lastQuickViewTrigger?.focus) {
      this.lastQuickViewTrigger.focus({ preventScroll: true })
    }

    this.lastQuickViewTrigger = null
  }

  handleEscape (event) {
    if (event.key === 'Escape') this.closeQuickView()
  }

  formatMoney (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, this.dataset.moneyFormat)
    }

    const format = this.dataset.moneyFormat || '₹{{amount}}'
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)
    const token = placeholder ? placeholder[1] : 'amount'

    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (number == null || Number.isNaN(number)) return '0'

      const value = (number / 100).toFixed(precision)
      const parts = value.split('.')
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0]
    }

    let value = ''

    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.')
        break
      default:
        value = formatWithDelimiters(cents, 2)
    }

    return format.replace(placeholder?.[0] || '{{amount}}', value)
  }
}

if (!customElements.get('sea-shoppable-videos')) {
  customElements.define('sea-shoppable-videos', SeaShoppableVideos)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
